import React from "react";
import Layout from "./../components/Layout";
import user from "../assets/images/user.svg";
import {
  Box,
  Typography,
  Grid
} from "@mui/material";

const About = () => {
  return (
    <Layout>
      <Typography className="text-center"
        align="center"
        sx={{
          fontFamily: 'Baloo Bhaijaan',
          color: '#3a54b4',
          textAlign: { xs: 'center', sm: 'center' },
          '@media (max-width:500px)': { // Mobile
            order: 1, // Move above image on mobile
          },
          fontSize: { xs: '2rem', sm: '2rem', md: '4rem' },
        }}
      >
        <b>Let me introduce myself!</b>
      </Typography>
      <Box sx={{ padding: 2 }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          {/* Image */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              '@media (max-width:600px)': { // Mobile
                order: 1, // Move below text on mobile
              },
            }}
          >
            <img
              src={user}
              alt="description"
              style={{
                borderRadius: '50%',
                maxWidth: '100%',
                height: 'auto'
              }}
            />
          </Grid>

          {/* Text */}
          <Grid
            item
            xs={12}
            sm={6}
            md={8}
            sx={{
              fontFamily: 'Baloo Bhaijaan',
              textAlign: { xs: 'center', sm: 'left' },
              '@media (max-width:600px)': { // Mobile
                order: 1, // Move above image on mobile
              },
            }}
          >
            {/* <Typography
              sx={{
                fontFamily: 'Baloo Bhaijaan',
                textAlign: { xs: 'center', sm: 'left' },
                color: '#3a54b4',
                fontSize: { xs: '2rem', sm: '2rem', md: '3rem' },
              }}
            >
              I'm Dr. Ashitha Suresh, 
            </Typography> */}
              <Typography
    sx={{
      mb: 2,
      fontFamily: "Baloo Bhaijaan",
      fontSize: { xs: "1rem", md: "1.3rem" },
    }}
  >
    Hi! I’m <b>Dr. Ashitha Suresh</b>, a veterinarian-specifically a dog and cat
    vet, and even more specifically, a vet gynaecologist with a PhD to prove it.
  </Typography>
            {/* <Typography
              sx={{
                fontFamily: 'Baloo Bhaijaan',
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: '1rem', sm: '1rem', md: '1.5rem' },
              }}
            > When I was seven, I decided I was going to be an Animal Doctor, years before I learnt the word veterinarian. 2 decades later, here I am. Dog and cat health was and will always be my calling, and my goal is to use the knowledge I have gained (from all my years of education and being a pet parent myself), to help pet parents make their pets happier and healthier, and reap the benefits of the human animal bond. Whether you're a new pet parent, a seasoned pet parent, or contemplating the decision, we all have something new to learn from our animals every single day. I’m so glad to have you on this crazy hard, but deeply fulfilling journey!
            </Typography> */}
              <Typography
    sx={{
      mb: 2,
      fontFamily: "Baloo Bhaijaan",
      fontSize: { xs: "1rem", md: "1.3rem" },
    }}
  >
    During my PhD days, while scrolling through posts of silly puppies and
    kittens, I wished there was more content created specifically for Indian pet
    parents-content that was simple, fun, and practical. Eventually, because I'm
    impatient that way, I stopped wishing and started creating it myself.
  </Typography>

  <Typography
    sx={{
      mb: 2,
      fontFamily: "Baloo Bhaijaan",
      fontSize: { xs: "1rem", md: "1.3rem" },
    }}
  >
    Since Instagram doesn’t allow me to go <b>deep</b> into important topics, I
    launched <a
  href="https://practicalpetparenting.com"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    color: "#3a54b4",
    fontWeight: "bold",
    textDecoration: "none",
  }}
  onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
  onMouseOut={(e) => (e.target.style.textDecoration = "none")}
>
  PracticalPetParenting.com
</a>, where I can share detailed,
    evidence-based information to help pet parents make informed decisions.
  </Typography>

  <Typography
    sx={{
      mb: 2,
      fontFamily: "Baloo Bhaijaan",
      fontSize: { xs: "1rem", md: "1.3rem" },
    }}
  >
    I’m a huge nerd and still studying to this day-I apparently still haven’t
    had enough after <b>ten years</b>! Right now, I’m expanding my knowledge in
    pet nutrition so I can help pet parents feed their furry companions in a
    wholesome, practical, and sustainable way.
  </Typography>

  <Typography
    sx={{
      mb: 2,
      fontFamily: "Baloo Bhaijaan",
      fontSize: { xs: "1rem", md: "1.3rem" },
    }}
  >
    I’m also a seasoned dog mom and a first-time toddler mom, so my days are
    filled with parenting multiple species and discovering just how similar-yet
    wonderfully different-they are. These amazing little beings teach me
    something new every day and ensure I practice everything I recommend to pet
    parents.
  </Typography>

  <Typography
    sx={{
      mb: 2,
      fontFamily: "Baloo Bhaijaan",
      fontSize: { xs: "1rem", md: "1.3rem" },
    }}
  >
    I believe everyone deserves to experience the joy of understanding and
    connecting with animals. In today's world, where every aspect of pet care
    seems to come with endless opinions and studies, my goal is to cut through
    the noise, avoid unnecessary complexity, and help you do what matters
    most-your best for your pets.
  </Typography>

  <Typography
    sx={{
      fontFamily: "Baloo Bhaijaan",
      fontSize: { xs: "1rem", md: "1.3rem" },
    }}
  >
    Here you'll find practical blog articles, helpful resources, and links to
    content in different formats. Whether you enjoy reading detailed guides,
    listening to podcasts, or watching short-form content, there's something
    here for you. If you need personalized help with your pet's nutrition or
    diet, simply use the <b>Enquire</b> button on the Links page, and I'll be
    happy to get in touch.
  </Typography>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default About;